import type { TRuleWithTheme } from '@ackee/fela';

export const container: TRuleWithTheme = ({ theme: { colors } }) => ({
    display: 'inline',

    fontWeight: '700',
    fontSize: '0.75rem',
    lineHeight: '1.25rem',
    letterSpacing: '2.6px',

    padding: 0,

    '::before': {
        content: '"// "',
        color: colors.blue,
    },
});

export const listItem: TRuleWithTheme = ({ theme: { colors } }) => ({
    padding: 0,
    display: 'inline',

    ':not(:last-child):after': {
        color: colors.blue,
        content: '", "',
    },
});

export const link: TRuleWithTheme = () => ({
    textTransform: 'uppercase',
    textDecoration: 'none',
});
